const MAX_SIZE = 5;

import {
  Multimedia,
  MultimediaKeyOption,
  MultimediaType,
  MultimediaOption,
} from "@/@types/chatbots/multimedia";
import { MediaNode } from "@/@types/chatbots";

import { NodeType } from "@/app/chatbots/utils/enums";

const MULTIMEDIA_TYPES: Record<Multimedia, MultimediaType> = {
  [Multimedia.Image]: {
    type: Multimedia.Image,
    formats: {
      values: ["JPG", "JPEG", "PNG", "jpg", "png", "jpeg"],
      accept: "image/jpeg, image/png, image/jpg",
    },
    max_size: MAX_SIZE,
    type_in_node: NodeType.MessageWithImage,
  },
  [Multimedia.Video]: {
    type: Multimedia.Video,
    formats: { values: ["MP4"], accept: "video/mp4" },
    max_size: MAX_SIZE,
    type_in_node: NodeType.MessageWithVideo,
  },
  [Multimedia.Document]: {
    type: Multimedia.Document,
    formats: {
      values: ["PDF"],
      accept:
        "application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    max_size: MAX_SIZE,
    type_in_node: NodeType.MessageWithDocument,
  },
};

const MULTIMEDIA_OPTIONS: Record<MultimediaKeyOption, MultimediaOption> = {
  [MultimediaKeyOption.Document]: {
    title: "Adjuntar documento",
    multimedia: [Multimedia.Document],
    max_size_title: `Máx ${MAX_SIZE}MB`,
  },
  [MultimediaKeyOption.Media]: {
    title: "Adjuntar multimedia",
    multimedia: [Multimedia.Image, Multimedia.Video],
    max_size_title: `Máx ${MAX_SIZE}MB`,
  },
};

const formattedMedia = (dataSource: MediaNode, keyMedia: string) => {
  if (!dataSource || !dataSource[keyMedia as keyof typeof dataSource]) return;
  return {
    uid: "1",
    media: dataSource[keyMedia as keyof typeof dataSource],
    name: dataSource[`${keyMedia}_filename` as keyof typeof dataSource] || dataSource.filename,
    type: dataSource[`${keyMedia}_type` as keyof typeof dataSource] || dataSource.media_type,
    url: dataSource[`${keyMedia}_url` as keyof typeof dataSource] || dataSource.media_url,
    status: "done",
  };
};

export { MULTIMEDIA_OPTIONS, MULTIMEDIA_TYPES, formattedMedia };
